import { olx } from 'openlayers';
import { BehaviorSubject } from 'rxjs';
import { CustomOlControl } from './custom-ol-control';

export class ToggleControl extends CustomOlControl {
  isToggled$: BehaviorSubject<boolean>;

  constructor(
    className: string = '',
    protected classNameOn: string = '',
    protected classNameOff: string = classNameOn,
    options: olx.control.ControlOptions = {}
  ) {
    super(() => this.click(), className, options);

    this.isToggled$ = new BehaviorSubject<boolean>(false);

    this.isToggled$.subscribe(isToggled => {
      this.setClass(isToggled ? this.classNameOn : this.classNameOff);
    });
  }

  click() {
    this.isToggled$.next(!this.isToggled$.value);
  }
}
